// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.forecase-suggest-pop[data-v-3a1e5b76] {\r\n  width: auto !important;\r\n  min-width: 0 !important;\r\n  max-width: 500px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
